import Component from './modal-header';
export default Component;
